import "./Avatar.scss";
import Layout from "../../components/Layout/Layout";
import avatars from "../../assets/avatars/avatars";
import { updateUserAvatar } from "../../api/userService";

const Avatar = () => {
  const handleClick = async (url) => {
    await updateUserAvatar(url);
    location.reload();
  };

  const imgJSX = avatars.map((avatar) => (
    <button
      className="avatar__img-container"
      key={avatar.key}
      onClick={() =>
        handleClick(
          `https://firebasestorage.googleapis.com/v0/b/save-oom-oxna.appspot.com/o/avatars%2F${avatar.avatarName}.svg?alt=media&token=${avatar.key}`
        )
      }
    >
      <img
        className="avatar__img"
        src={`https://firebasestorage.googleapis.com/v0/b/save-oom-oxna.appspot.com/o/avatars%2F${avatar.avatarName}.svg?alt=media&token=${avatar.key}`}
        alt="profile of avatar"
      />
    </button>
  ));

  return (
    <Layout requiresAuth={true}>
      <section className="avatar">{imgJSX}</section>
    </Layout>
  );
};

export default Avatar;
